import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VuePrlx from 'vue-prlx'
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(VuePrlx);

Vue.config.productionTip = false

new Vue({
  router,
  created () {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')
